module.exports = {"extension_needed":null,"extension_why":null,"extension_why_other":null,"loan_paid_off":null,"property_status":null,"complete_rehab_estimation":null,"property_status_other":null,"exit_strategy":null,"exit_strategy_other":null,"point_of_contact":null,"phone_number":null,"projected_payoff_date":null,"additional_information":null}


//////////////////
// WEBPACK FOOTER
// ./src/components/my_deals/actions/extension/resources/model.json
// module id = cFNZ
// module chunks = 1